module.exports = __webpack_public_path__ + "img/20191014165421360截图20191014161241803.8f8335c7.jpg";